import React from 'react';
import { SegmentedControl } from '@mantine/core';
import { UrgencyBand } from '../utils/stackRanking';
import './PriorityBandSelector.css';

interface PriorityBandSelectorProps {
  value: UrgencyBand | null;
  onChange: (value: UrgencyBand | null) => void;
}

export const PriorityBandSelector: React.FC<PriorityBandSelectorProps> = ({
  value,
  onChange,
}) => {
  // No band selected means the task is captured as "Unranked" — there is no
  // explicit "Backlog" segment. An empty value leaves the control unselected.
  const segmentedValue = value ?? '';

  return (
    <div className="priority-band-selector">
      <SegmentedControl
        value={segmentedValue}
        onChange={(val) => onChange(val ? (val as UrgencyBand) : null)}
        data={[
          { label: 'Low', value: 'low' },
          { label: 'Medium', value: 'medium' },
          { label: 'High', value: 'high' },
        ]}
        fullWidth
        classNames={{
          root: 'priority-band-root',
          label: 'priority-band-label',
          indicator: 'priority-band-indicator',
          control: 'priority-band-control',
        }}
        styles={{
          root: {
            backgroundColor: '#f0f0f0',
          },
        }}
        color={
          value === null
            ? 'gray'
            : value === 'low'
              ? 'gray'
              : value === 'medium'
                ? 'orange'
                : 'red'
        }
      />
    </div>
  );
};
